/**
 * homeTabStore — 全局追踪当前 Home 页激活的 Tab
 * 用于 SharedNav isActive 高亮，以及 URL search params 同步
 *
 * 故意不用 React Context，避免跨页面 Provider 嵌套，用轻量 pub-sub 即可
 */

export type HomeTab = 'talents' | 'hired' | 'workspace' | 'training' | 'workflow';

const VALID: HomeTab[] = ['talents', 'hired', 'workspace', 'training', 'workflow'];

// 初始值：从当前 URL search params 读取，支持刷新保留
function initTab(): HomeTab {
  try {
    const p = new URLSearchParams(window.location.search).get('tab');
    if (p && (VALID as string[]).includes(p)) return p as HomeTab;
  } catch { /* noop */ }
  return 'talents';
}

let current: HomeTab = initTab();
const listeners = new Set<(tab: HomeTab) => void>();

export const homeTabStore = {
  get: (): HomeTab => current,
  set: (tab: HomeTab, force = false) => {
    if (tab === current && !force) return;
    current = tab;
    listeners.forEach(fn => fn(tab));
  },
  /** 强制触发所有订阅者，即使 tab 值未变（用于工作台模式切换场景） */
  forceNotify: () => {
    listeners.forEach(fn => fn(current));
  },
  subscribe: (fn: (tab: HomeTab) => void) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};
